import { useMemo, useState } from 'react';

import { Input } from 'antd';
import { LeadManagementType } from '../../types/data/lead-management.type';
import { SearchOutlined } from '@ant-design/icons';
import TableComponent from '../table';
import { TableType } from '../../enums/table-type.enum';

const { Search } = Input;

type ConfigurationProps = {
  data?: LeadManagementType[];
  loading?: boolean;
  disabled?: boolean;
  handleEdit?: any;
  handleRemove?: any;
  handleDragAndDrop: any;
  isDataFetching?: boolean;
  selectedRows?: string[];
  handleRowSelection?: (rows: string[]) => void;
};

const LeadManagementComponent = (props: ConfigurationProps) => {
  const [searchText, setSearchText] = useState<string>('');

  // Filter data based on search text - filtering by 'name' field
  const filteredData = useMemo(() => {
    if (!props.data || !searchText.trim()) {
      return props.data;
    }

    return props.data.filter(item => {
      const ruleName = item.name || '';
      return ruleName.toLowerCase().includes(searchText.toLowerCase());
    });
  }, [props.data, searchText]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Search
          placeholder='Search by Rule Name'
          allowClear
          enterButton={<SearchOutlined />}
          size='middle'
          onSearch={handleSearch}
          onChange={handleSearchChange}
          value={searchText}
          style={{ width: 300 }}
        />
      </div>

      <TableComponent
        handleSelect={props.handleRowSelection}
        selectedRowKeys={props.selectedRows}
        selection
        pagination={false}
        handleEdit={props.handleEdit}
        handleRemove={props.handleRemove}
        disabled={props.disabled}
        loading={props.loading}
        data={filteredData}
        tableType={TableType.LEAD_MANAGEMENT}
        handleDragAndDrop={props.handleDragAndDrop}
        isDataFetching={props.isDataFetching}
      />
    </div>
  );
};

export default LeadManagementComponent;
